module.exports = __webpack_public_path__ + "static/media/vf_wtop_core.adc5361a.svg";